import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import colors from 'shared/modules/common/constants/colors';

type Props = {
  progress: number;
};

export default function GradientProgress({ progress }: Props) {
  const widthStyle = { width: `${progress * 100}%` };

  return (
    <LinearGradient
      style={styles.container}
      colors={[colors.white, '#d2dae4']}
      start={[0, 1]}
      end={[0, 0]}
    >
      <LinearGradient
        colors={['#E5258C', '#823CD7']}
        /** will do an approximately 135-degree gradient */
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 6 }}
        style={[styles.progressBar, widthStyle]}
      />
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    height: 12,
    overflow: 'hidden',
  },
  progressBar: {
    width: '1%',
    height: 12,
    borderRadius: 5,
    ...Platform.select({
      android: {
        elevation: 3,
      },
      ios: {
        shadowColor: '#a8bed2',
        shadowOpacity: 1,
        shadowRadius: 16,
        shadowOffset: {
          width: 4,
          height: 3,
        },
      },
    }),
  },
});
